type ResultsPageViewParams = {
	mode?: string;
	token?: string;
};

export function getResultsPageViewSource({
	token,
}: ResultsPageViewParams): "shared_link" | "organic" {
	return token ? "shared_link" : "organic";
}
